class vendorRelated extends HTMLElement {
  constructor() {
    super();
    
    const searchTerm = this.dataset.vendor;
    if (!searchTerm) return; // Don't fetch if no vendor is set

    // 1. CRITICAL FIX: Wrap in vendor:"" and encode it so Shopify ONLY searches the vendor field
    // 2. Added &type=product to prevent it from searching blog posts/pages
    const query = encodeURIComponent(`vendor:"${searchTerm}"`);
    const requestUrl = `/search?q=${query}&type=product&view=vendor`;

    fetch(requestUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
      })
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const newHtml = html.querySelector('.vendor-grid');

        // Safety check: If the search results page doesn't have a .vendor-grid, don't crash
        if (newHtml) {
          this.innerHTML = newHtml.outerHTML;
          
          // Safely initialize sliders only if the function exists
          if (typeof makeSliders === 'function') {
            makeSliders();
          }
        } else {
          // Optional: Do something if no products are found
          this.innerHTML = ''; 
        }
      })
      .catch((error) => {
        console.error('Error fetching vendor products:', error);
        this.innerHTML = ''; // Clear container on error
      });
  }
}

customElements.define('vendor-related', vendorRelated);